<div class="engagements-table-container">
  <div class="engagements-table-header">
    <h1>Engagements</h1>
    <input [formControl]="searchControl()" type="text" placeholder="Search" class="form-input form-input--search" data-cy="search">
  </div>

  @let isTableEmpty = dataSource()?.data.length === 0;

  <div
    class="engagements-table-wrapper bg-color-white"
    [ngClass]="{ 'overflow-hidden': isTableEmpty || listStatus() === LoadableStatus.LOADING }"
  >
    <table
      mat-table
      class="data-table__tbl engagements-table"
      matSort
      [matSortActive]="sortActive()"
      [matSortDirection]="sortDirection()"
      [dataSource]="dataSource()"
      (matSortChange)="sortChange.emit($event)"
    >
      <ng-container [matColumnDef]="EngagementColumn.ACCOUNT">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Account</th>
        <td mat-cell *matCellDef="let engagement" [innerHTML]="engagement[EngagementColumn.ACCOUNT] | highlight: highlightTerm()"></td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.ENGAGEMENT">
        <th mat-header-cell *matHeaderCellDef mat-sort-header class="name-header">Engagement</th>
        <td mat-cell *matCellDef="let engagement" class="name-cell">
          <div class="engagement-name-cell">
            <div class="engagement-name-cell-text" [innerHTML]="engagement[EngagementColumn.ENGAGEMENT] | highlight: highlightTerm()"></div>

            @if (engagement.actionRequired) { 
              <pill color="red" [dark]="true" size="small" value="ACTION REQUIRED" />
            }
          </div>
        </td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.PARTNER">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Partner</th>
        <td mat-cell *matCellDef="let engagement" data-cy="invoice-number" [innerHTML]="engagement[EngagementColumn.PARTNER] | highlight: highlightTerm()"></td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.START_DATE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
        <td mat-cell *matCellDef="let engagement">{{ engagement[EngagementColumn.START_DATE] }}</td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.EXECUTED_DATE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Executed Date</th>
        <td mat-cell *matCellDef="let engagement">
          {{ engagement[EngagementColumn.EXECUTED_DATE] ? engagement[EngagementColumn.EXECUTED_DATE] : '- -' }}
        </td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.STATUS">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td mat-cell *matCellDef="let engagement">
          @if (engagement.prepaymentStatus) {
            <pill [color]="EngagementListPrepaymentStatusColor[engagement.prepaymentStatus]" [value]="EngagementListPrepaymentStatusDisplay[engagement.prepaymentStatus]" />
          } @else {
            <pill [color]="EngagementListStatusColor[engagement.status]" [value]="EngagementListStatusDisplay[engagement.status]" />
          }
        </td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.SENT_DATE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Sent</th>
        <td mat-cell *matCellDef="let engagement">{{ engagement[EngagementColumn.SENT_DATE] | timeAgo }}</td>
      </ng-container>

      <ng-container [matColumnDef]="EngagementColumn.PAYMENT_TYPE">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment Type</th>
        <td mat-cell *matCellDef="let engagement">
          <pill [color]="EngagementListPaymentTypeColor[engagement.paymentType]" [value]="EngagementListPaymentTypeDisplay[engagement.paymentType]"></pill>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns(); sticky: true" class="data-table__row"></tr>
      <tr
        mat-row
        *matRowDef="let engagement; columns: displayedColumns()"
        (click)="rowClick.emit(engagement)"
        class="data-table__row data-table__row--selectable"
        [class.error-row]='engagement.prepaymentStatus === "FAILED"'
      >
      </tr>
    </table>

    @if (listStatus() !== LoadableStatus.LOADED) {
      <div class="engagements-status-indicator">
        @if (listStatus() === LoadableStatus.DEFAULT || listStatus() === LoadableStatus.LOADING) {
          <mat-spinner />
        }

        @if (listStatus() === LoadableStatus.ERROR) {
          <div class="alert alert--error">There was an error retrieving engagement records. Please try again.</div>
        }
      </div>
    }

    @if (isTableEmpty && listStatus() !== LoadableStatus.LOADING) {
      <div class="engagements-status-indicator">No records match your search.</div>
    }
  </div>

  @if (paginationOptions().totalItems > paginationOptions().pageSize) {
    <div class="engagements-table-footer bg-color-white">
      <mat-paginator
        class="legacy-layout"
        (page)="pageChange.emit($event)"
        [length]="paginationOptions().totalItems"
        [pageIndex]="paginationOptions().currentPage"
        [pageSize]="paginationOptions().pageSize"
        [pageSizeOptions]="paginationOptions().pageSizeOptions"
        [showFirstLastButtons]="true"
      />
    </div>
  }
</div>
